import { useState, useEffect } from "react"

export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState("up")
  const [scrollY, setScrollY] = useState(0)
  const [isTop, setIsTop] = useState(true)

  useEffect(() => {
    let lastScrollY = window.pageYOffset

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset
      const direction = scrollY > lastScrollY ? "down" : "up"

      // Aggiorna lo stato solo se la direzione è cambiata o si è tornati in cima
      if (direction !== scrollDirection || (scrollY === 0 && !isTop)) {
        setScrollDirection(direction)
      }

      // Aggiorna posizione scroll
      setScrollY(scrollY)

      // Se siamo in cima
      setIsTop(scrollY < 10)

      lastScrollY = scrollY > 0 ? scrollY : 0
    }

    // Aggiungi event listener con throttling
    let ticking = false
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateScrollDirection()
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener("scroll", onScroll)

    return () => window.removeEventListener("scroll", onScroll)
  }, [scrollDirection, isTop])

  return { scrollDirection, scrollY, isTop }
}
